import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Moment from 'moment';
import "moment/locale/ko";

function StockAdjustmentDetailModal({ title, onClose, id, originRows, handleView, typeModalOption }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [originItemRows, setOriginItemRows] = useState([]);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [originLotRows, setOriginLotRows] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    stock_adjustment_id: null,
    stock_adjustment_number: '',
    stock_adjustment_type: '',
    stock_adjustment_type_name: '',
    stock_adjustment_date: '',
    stock_adjustment_approval_user_id: '',
    stock_adjustment_approval_user_name: '',
    stock_adjustment_reason: ''
  });

  const handleInitSelect = () => {
    setUpdateItemRows([]);
    setUpdateLotRows([]);
    setUpdateFileRows([]);

    setInputs({
      stock_adjustment_id: Number(originRows[0].stock_adjustment_id),
      stock_adjustment_number: originRows[0].stock_adjustment_number,
      stock_adjustment_type: Number(originRows[0].stock_adjustment_type),
      stock_adjustment_type_name: originRows[0].stock_adjustment_type_name,
      stock_adjustment_date: originRows[0].stock_adjustment_date,
      stock_adjustment_approval_user_id: Number(originRows[0].stock_adjustment_approval_user_id),
      stock_adjustment_approval_user_name: originRows[0].stock_adjustment_approval_user_name,
      stock_adjustment_reason: originRows[0].stock_adjustment_reason
    });

    var itemData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.stock_adjustment_item_seq !== 'undefined' && item.stock_adjustment_item_seq === item2.stock_adjustment_item_seq;
        }) === index
      );
    });

    // List정렬
    itemData = itemData.sort(function(a, b) { 
      return a.stock_adjustment_item_seq < b.stock_adjustment_item_seq ? -1 : a.stock_adjustment_item_seq > b.stock_adjustment_item_seq ? 1 : 0;
    });

    setItemRows(itemData.map((item, index) => ({
      id: item.stock_adjustment_item_seq,
      stock_adjustment_item_id: item.stock_adjustment_item_id,
      stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.stock_adjustment_item_spec, item.stock_adjustment_item_width, item.stock_adjustment_item_depth, item.stock_adjustment_item_height),
      stock_adjustment_item_name: item.stock_adjustment_item_name,
      stock_adjustment_item_a_stock: item.stock_adjustment_item_a_stock,
      stock_adjustment_item_b_stock: item.stock_adjustment_item_b_stock,
      stock_adjustment_item_count: item.stock_adjustment_item_count,
      stock_adjustment_save_workplace_id: null,
      stock_adjustment_save_workplace_name: '',
      stock_adjustment_save_warehouse_id: null,
      stock_adjustment_save_warehouse_name: '',
      stock_adjustment_save_section_id: null,
      stock_adjustment_save_section_name: '',
      stock_adjustment_item_reason: item.stock_adjustment_item_reason,
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginItemRows(itemData.map((item, index) => ({
      id: item.stock_adjustment_item_seq,
      stock_adjustment_item_id: item.stock_adjustment_item_id,
      stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.stock_adjustment_item_spec, item.stock_adjustment_item_width, item.stock_adjustment_item_depth, item.stock_adjustment_item_height),
      stock_adjustment_item_name: item.stock_adjustment_item_name,
      stock_adjustment_item_a_stock: item.stock_adjustment_item_a_stock,
      stock_adjustment_item_b_stock: item.stock_adjustment_item_b_stock,
      stock_adjustment_item_count: item.stock_adjustment_item_count,
      stock_adjustment_save_workplace_id: null,
      stock_adjustment_save_workplace_name: '',
      stock_adjustment_save_warehouse_id: null,
      stock_adjustment_save_warehouse_name: '',
      stock_adjustment_save_section_id: null,
      stock_adjustment_save_section_name: '',
      stock_adjustment_item_reason: item.stock_adjustment_item_reason,
      row_type: 'O',
      update_type: 'N'
    })));

    var lotData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.lot_stock_adjustment_item_lot_seq !== 'undefined' && item.lot_stock_adjustment_item_lot_seq === item2.lot_stock_adjustment_item_lot_seq && item.lot_stock_adjustment_item_id === item2.stock_adjustment_item_id;
        }) === index
      );
    });
    
    lotData = lotData.sort(function(a, b) { 
      return a.lot_stock_adjustment_item_lotno < b.lot_stock_adjustment_item_lotno ? -1 : a.lot_stock_adjustment_item_lotno > b.lot_stock_adjustment_item_lotno ? 1 : 0;
    });

    setLotRows(lotData.map((item, index) => ({
      id: item.lot_stock_adjustment_item_lot_seq,
      upper_id: item.lot_stock_adjustment_item_id,
      lot_no: item.lot_stock_adjustment_item_lotno,
      lot_stock_adjustment_item_lot_type: item.lot_stock_adjustment_item_lot_type,
      lot_stock_adjustment_item_lot_type_name: item.lot_stock_adjustment_item_lot_type_name,
      lot_stock_adjustment_item_id: item.lot_stock_adjustment_item_id,
      lot_stock_adjustment_item_name: item.lot_stock_adjustment_item_name,
      lot_stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_stock_adjustment_item_spec, item.lot_stock_adjustment_item_width, item.lot_stock_adjustment_item_depth, item.lot_stock_adjustment_item_height),
      lot_stock_adjustment_save_workplace_id: item.lot_stock_adjustment_save_workplace_id,
      lot_stock_adjustment_save_workplace_name: item.lot_stock_adjustment_save_workplace_name,
      lot_stock_adjustment_save_warehouse_id: item.lot_stock_adjustment_save_warehouse_id,
      lot_stock_adjustment_save_warehouse_name: item.lot_stock_adjustment_save_warehouse_name,
      lot_stock_adjustment_save_section_id: item.lot_stock_adjustment_save_section_id,
      lot_stock_adjustment_save_section_name: item.lot_stock_adjustment_save_section_name,
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginLotRows(lotData.map((item, index) => ({
      id: item.lot_stock_adjustment_item_lot_seq,
      upper_id: item.lot_stock_adjustment_item_id,
      lot_no: item.lot_stock_adjustment_item_lotno,
      lot_stock_adjustment_item_lot_type: item.lot_stock_adjustment_item_lot_type,
      lot_stock_adjustment_item_lot_type_name: item.lot_stock_adjustment_item_lot_type_name,
      lot_stock_adjustment_item_id: item.lot_stock_adjustment_item_id,
      lot_stock_adjustment_item_name: item.lot_stock_adjustment_item_name,
      lot_stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_stock_adjustment_item_spec, item.lot_stock_adjustment_item_width, item.lot_stock_adjustment_item_depth, item.lot_stock_adjustment_item_height),
      lot_stock_adjustment_save_workplace_id: item.lot_stock_adjustment_save_workplace_id,
      lot_stock_adjustment_save_workplace_name: item.lot_stock_adjustment_save_workplace_name,
      lot_stock_adjustment_save_warehouse_id: item.lot_stock_adjustment_save_warehouse_id,
      lot_stock_adjustment_save_warehouse_name: item.lot_stock_adjustment_save_warehouse_name,
      lot_stock_adjustment_save_section_id: item.lot_stock_adjustment_save_section_id,
      lot_stock_adjustment_save_section_name: item.lot_stock_adjustment_save_section_name,
      row_type: 'O',
      update_type: 'N'
    })));

    setUpdateLotRows(lotData.map((item, index) => ({
      id: item.lot_stock_adjustment_item_lot_seq,
      upper_id: item.lot_stock_adjustment_item_id,
      lot_no: item.lot_stock_adjustment_item_lotno,
      lot_stock_adjustment_item_lot_type: item.lot_stock_adjustment_item_lot_type,
      lot_stock_adjustment_item_lot_type_name: item.lot_stock_adjustment_item_lot_type_name,
      lot_stock_adjustment_item_id: item.lot_stock_adjustment_item_id,
      lot_stock_adjustment_item_name: item.lot_stock_adjustment_item_name,
      lot_stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_stock_adjustment_item_spec, item.lot_stock_adjustment_item_width, item.lot_stock_adjustment_item_depth, item.lot_stock_adjustment_item_height),
      lot_stock_adjustment_save_workplace_id: item.lot_stock_adjustment_save_workplace_id,
      lot_stock_adjustment_save_workplace_name: item.lot_stock_adjustment_save_workplace_name,
      lot_stock_adjustment_save_warehouse_id: item.lot_stock_adjustment_save_warehouse_id,
      lot_stock_adjustment_save_warehouse_name: item.lot_stock_adjustment_save_warehouse_name,
      lot_stock_adjustment_save_section_id: item.lot_stock_adjustment_save_section_id,
      lot_stock_adjustment_save_section_name: item.lot_stock_adjustment_save_section_name,
      row_type: 'O',
      update_type: 'N'
    })));

    var fileData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.stock_adjustment_file_id !== 'undefined' && item.stock_adjustment_file_id === item2.stock_adjustment_file_id;
        }) === index
      );
    });

    setFileRows(fileData.map((item, index) => ({
      id: item.stock_adjustment_file_id,
      file_name_sever: item.stock_adjustment_file_name_sever,
      file_size: item.stock_adjustment_file_size,
      file_type: item.stock_adjustment_file_type,
      file_extension: item.stock_adjustment_file_extension,
      file_name: item.stock_adjustment_file_name,
      file_type_name: item.stock_adjustment_file_type_name,
      file_size_dp: item.stock_adjustment_file_size_dp,
      reg_user_name: item.stock_adjustment_file_user_name,
      reg_datetime: Moment(item.stock_adjustment_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginFileRows(fileData.map((item, index) => ({
      id: item.stock_adjustment_file_id,
      file_name_sever: item.stock_adjustment_file_name_sever,
      file_size: item.stock_adjustment_file_size,
      file_type: item.stock_adjustment_file_type,
      file_extension: item.stock_adjustment_file_extension,
      file_name: item.stock_adjustment_file_name,
      file_type_name: item.stock_adjustment_file_type_name,
      file_size_dp: item.stock_adjustment_file_size_dp,
      reg_user_name: item.stock_adjustment_file_user_name,
      reg_datetime: Moment(item.stock_adjustment_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));
    
  };

  const handleSetting = () => {
    setItemColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_item_id', headerName: 'stock_adjustment_item_id', headerAlign: 'center', align:'center' },
      { field: 'stock_adjustment_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'stock_adjustment_item_spec', headerName: '규격', width: 230, headerAlign: 'center', align:'left' },
      { field: 'stock_adjustment_item_b_stock', headerName: '변경 전 재고', type: 'number', width: 100, headerAlign: 'center', align:'right' },
      { field: 'stock_adjustment_item_a_stock', headerName: '변경 후 재고', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
      { field: 'stock_adjustment_item_count', headerName: 'stock_adjustment_item_count', type: 'number', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_save_workplace_id', headerName: 'stock_adjustment_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_save_warehouse_id', headerName: 'stock_adjustment_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_save_section_id', headerName: 'stock_adjustment_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_save_workplace_name', headerName: 'stock_adjustment_save_workplace_name',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_save_warehouse_name', headerName: 'stock_adjustment_save_warehouse_name', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_save_section_name', headerName: 'stock_adjustment_save_section_name',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_item_reason', headerName: '조정 사유', width: 260, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 160, headerAlign: 'center', align:'center' },
      { field: 'lot_stock_adjustment_item_lot_type', headerName: 'lot_stock_adjustment_item_lot_type',width: 0, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_item_lot_type_name', headerName: '구분', width: 70, headerAlign: 'center', align:'center' },
      { field: 'lot_stock_adjustment_item_id', headerName: 'lot_stock_adjustment_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_stock_adjustment_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'lot_stock_adjustment_item_spec', headerName: '규격', width: 175, headerAlign: 'center', align:'left' },
      { field: 'lot_stock_adjustment_save_workplace_id', headerName: 'lot_stock_adjustment_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_save_workplace_name', headerName: '사업장',width: 100, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_save_warehouse_id', headerName: 'lot_stock_adjustment_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_stock_adjustment_save_warehouse_name', headerName: '창고', width: 100, headerAlign: 'center', align:'left' },
      { field: 'lot_stock_adjustment_save_section_id', headerName: 'lot_stock_adjustment_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_save_section_name', headerName: '구역',width: 100, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 320, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
    
    setItemColumnVisibilityModel({
      id: false,
      stock_adjustment_item_id: false,
      stock_adjustment_item_name: true,
      stock_adjustment_item_spec: true,
      stock_adjustment_item_b_stock: true,
      stock_adjustment_item_a_stock: true,
      stock_adjustment_item_count: false,
      stock_adjustment_save_workplace_id: false,
      stock_adjustment_save_warehouse_id: false,
      stock_adjustment_save_section_id: false,
      stock_adjustment_save_workplace_name: false,
      stock_adjustment_save_warehouse_name: false,
      stock_adjustment_save_section_name: false,
      stock_adjustment_item_reason: true,
      row_type: false,
      update_type: false
    })

    setLotColumnVisibilityModel ({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_stock_adjustment_item_lot_type: false,
      lot_stock_adjustment_item_lot_type_name: true,
      lot_stock_adjustment_item_id: false,
      lot_stock_adjustment_item_name: true,
      lot_stock_adjustment_item_spec: true,
      lot_stock_adjustment_save_workplace_id: false,
      lot_stock_adjustment_save_workplace_name: true,
      lot_stock_adjustment_save_warehouse_id: false,
      lot_stock_adjustment_save_warehouse_name: true,
      lot_stock_adjustment_save_section_id: false,
      lot_stock_adjustment_save_section_name: true,
      row_type: false,
      update_type: false
    })

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    stock_adjustment_item_id: false,
    stock_adjustment_item_name: true,
    stock_adjustment_item_spec: true,
    stock_adjustment_item_b_stock: true,
    stock_adjustment_item_a_stock: true,
    stock_adjustment_item_count: false,
    stock_adjustment_save_workplace_id: false,
    stock_adjustment_save_warehouse_id: false,
    stock_adjustment_save_section_id: false,
    stock_adjustment_save_workplace_name: false,
    stock_adjustment_save_warehouse_name: false,
    stock_adjustment_save_section_name: false,
    stock_adjustment_item_reason: true,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_stock_adjustment_item_lot_type: false,
    lot_stock_adjustment_item_lot_type_name: true,
    lot_stock_adjustment_item_id: false,
    lot_stock_adjustment_item_name: true,
    lot_stock_adjustment_item_spec: true,
    lot_stock_adjustment_save_workplace_id: false,
    lot_stock_adjustment_save_workplace_name: true,
    lot_stock_adjustment_save_warehouse_id: false,
    lot_stock_adjustment_save_warehouse_name: true,
    lot_stock_adjustment_save_section_id: false,
    lot_stock_adjustment_save_section_name: true,
    row_type: false,
    update_type: false
  });
  
  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);
  
  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="재고조정 정보" value="1" />
                <Tab label="재고조정 품목" value="2" />
                <Tab label="재고조정 Lot" value="3" />
                <Tab label="재고조정 파일" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정번호</div>
                        <div className="modal_filed_input">
                          <input type="text" value={inputs.stock_adjustment_number} name="stock_adjustment_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정유형<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" value={inputs.stock_adjustment_type_name} name="stock_adjustment_type_name" onChange={(e) => onChange(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' }} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정일자<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="date" value={inputs.stock_adjustment_date} name="stock_adjustment_date" onChange={(e) => onDateChange(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' }} readOnly />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정승인자</div>
                        <div className="modal_filed_input">
                          <input type="text" value={inputs.stock_adjustment_approval_user_name} name="stock_adjustment_approval_user_name" onChange={(e) => onChange(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' }} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정사유</div>
                        <div className="modal_filed_input">
                          <textarea name="stock_adjustment_reason" value={inputs.stock_adjustment_reason} onChange={(e) => onChange(e) } style={{width: '768px', height: '200px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none', backgroundColor: '#EFEFEF4D'}} autoComplete="off" readOnly >
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell' 
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell' 
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </PCModal>
  );
}

export default StockAdjustmentDetailModal;